export default __webpack_public_path__ + "static/media/csv_color.bb6931b8.svg";